/* eslint-disable prefer-destructuring */
import styled, { css } from "styled-components";
import { theme } from "../theme/toyotaTheme";
import * as MonthlyPrice from "./price/MonthlyPrice";
import * as CashPrice from "./price/CashPrice";
import * as Button from "../components/Button";
import * as Type from "../globals/Type";
import { CommonListItemStyle } from "../globals/List";

export const Wrapper = styled.dl`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 1.3rem;
    line-height: 2rem;

    ${CashPrice.Text} {
        margin-top: 0;
        font-size: 1.3rem;
        color: ${theme.colors.primaryBlack};
    }

    ${MonthlyPrice.Text} {
        font-size: 1.3rem;
        color: ${theme.colors.primaryBlack};
    }
`;

export const ListItemTerm = styled.dt.attrs(() => ({
    className: "t-milli-text",
}))<{ isBold?: boolean; hasTotalPrice?: boolean }>`
    ${CommonListItemStyle};
    width: 60%;
    font-family: ${({ isBold }) => (isBold ? theme.fonts.semiBold : theme.fonts.base)};
    text-align: start;

    ${({ hasTotalPrice }) =>
        hasTotalPrice &&
        css`
            flex-basis: 100% !important;
            width: 100% !important;
        `};
`;

export const ListItemValue = styled.dd.attrs(() => ({
    className: "t-milli-headline",
}))<{ hasTotalPrice?: boolean }>`
    ${CommonListItemStyle};
    width: 40%;
    font-family: ${theme.fonts.regular};
    text-align: end;

    ${({ hasTotalPrice }) =>
        hasTotalPrice &&
        css`
            flex-basis: 100% !important;
            width: 100% !important;
            text-align: right !important;
            border-top: 0 !important;
        `};
`;

export const RegularText = styled.span`
    font-family: ${theme.fonts.regular};
`;

export const MonthlyRateDisclaimer = styled.div`
    margin: ${theme.space[1]}px 0;
    text-align: start;

    ${Button.Link}, div, ${Type.SmallText} {
        font-size: 1.3rem;
        text-align: start;
        color: ${theme.colors.grey7};
    }
`;

export const DisclaimerWrapper = styled.span`
    font-size: 1.3rem;
    color: ${theme.colors.primaryBlack};
`;
